/// <amd-module name="SuiteCommerce.FeaturedCategory.Item.Collection"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.FeaturedCategory.Item.Collection", ["require", "exports", "underscore", "Backbone", "SuiteCommerce.FeaturedCategory.Item.Model", "SuiteCommerce.FeaturedCategory.Item.Configuration", "SuiteCommerce.FeaturedCategory.Common.Utils", "SuiteCommerce.FeaturedCategory.Common.Configuration"], function (require, exports, _, Backbone_1, Item_Model_1, Item_Configuration_1, Utils_1, Configuration_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ItemCollection = void 0;
    var ItemCollection = /** @class */ (function (_super) {
        __extends(ItemCollection, _super);
        function ItemCollection(elements, options) {
            var _this = _super.call(this, elements, options) || this;
            _this.model = Item_Model_1.ItemModel;
            if (options) {
                _this.environment = options.environment;
            }
            return _this;
        }
        ItemCollection.prototype.setURLForSearchApi = function (searchApiOptions) {
            var searchApiUrl = '/api/items';
            var searchParams = _.extend({
                limit: searchApiOptions.limit,
                commercecategoryid: searchApiOptions.commerceCategoryId,
            }, this.getSortFieldParam(searchApiOptions.sortingField), this.getFieldsetParam(), this.getSessionSearchApiParams());
            if (this.isPCVEnabled()) {
                _(searchParams).extend(this.getPCVParam());
            }
            this.url = Utils_1.Utils.addParamsToUrl(searchApiUrl, searchParams);
        };
        ItemCollection.prototype.getSortFieldParam = function (sortingField) {
            var sortFieldName = '';
            var sortFields = Item_Configuration_1.ItemConfiguration.siteSettingsSortfield;
            for (var i = 0; i < sortFields.length; i += 1) {
                var sortField = sortFields[i];
                if (sortField.sortfieldname === sortingField.sortfieldname) {
                    sortFieldName = sortField.sortfieldname + ":" + sortingField.direction;
                    break;
                }
            }
            return {
                sort: sortFieldName || 'relevance'
            };
        };
        ItemCollection.prototype.getFieldsetParam = function () {
            var customFieldset = Item_Configuration_1.ItemConfiguration.getFieldSetID;
            var fieldsetName = Item_Configuration_1.ItemConfiguration.activeFieldset;
            return {
                fieldset: customFieldset || fieldsetName || 'search'
            };
        };
        ItemCollection.prototype.getSessionSearchApiParams = function () {
            var _a, _b;
            var searchApiParams = {};
            var sessionInfo = this.environment.getSession();
            var locale = (sessionInfo && ((_a = sessionInfo.language) === null || _a === void 0 ? void 0 : _a.locale)) || '';
            var language = '';
            var country = '';
            var currency = (sessionInfo && ((_b = sessionInfo.currency) === null || _b === void 0 ? void 0 : _b.code)) || '';
            var priceLevel = (sessionInfo && sessionInfo.priceLevel) || '';
            var localeTokens;
            if (locale.indexOf('_') >= 0) {
                localeTokens = locale.split('_');
                language = localeTokens[0];
                country = localeTokens[1];
            }
            else {
                language = locale;
            }
            // SET API PARAMS
            if (language) {
                searchApiParams.language = language;
            }
            if (country) {
                searchApiParams.country = country;
            }
            if (currency) {
                searchApiParams.currency = currency;
            }
            searchApiParams.pricelevel = priceLevel;
            // No cache
            if (_(window.location.search).parseUrlOptions().nocache === 'T') {
                searchApiParams.nocache = 'T';
            }
            return searchApiParams;
        };
        ItemCollection.prototype.isPCVEnabled = function () {
            return Configuration_1.Configuration.get('siteSettings.isPersonalizedCatalogViewsEnabled') || false;
        };
        ItemCollection.prototype.getPCVParam = function () {
            return {
                use_pcv: 'T'
            };
        };
        ItemCollection.prototype.parse = function (response) {
            return _(response.items).compact() || null;
        };
        return ItemCollection;
    }(Backbone_1.Collection));
    exports.ItemCollection = ItemCollection;
});
